import { ReactNode } from 'react';

import VError from 'verror';

import Container from '~/components/shared/Dashboard/Layout/Container';

import { DashboardExtensionUserVerify } from './DashboardExtensionUserVerify';
import { UserDashboardMenu } from './UserDashboardMenu';

interface ContainerProps {
  title?: string;
  pageError: (errorContext: any) => VError;
  contentMaxWidth?: number;
  children: ReactNode;
}

const UserDashboardContainer = ({ children, title, pageError, contentMaxWidth }: ContainerProps) => {
  return (
    <Container title={title} pageError={pageError} menu={<UserDashboardMenu />} contentMaxWidth={contentMaxWidth}>
      <DashboardExtensionUserVerify>{children}</DashboardExtensionUserVerify>
    </Container>
  );
};

export default UserDashboardContainer;
